// MCP 连接器第三方 OAuth 授权成功落地页：授权流程在独立浏览器标签页完成，
// 第三方服务最终重定向到此页，与主应用外壳（导航/工作区初始化）无关
export default {
  path: '/aiChat/mcp-auth/success',
  name: 'mcpAuthSuccess',
  component: () => import(/* webpackChunkName: 'mcp-auth-success' */ '@/pages/aiAssistant/mcpAuth/success.vue'),
  meta: {
    requireAuth: false,
    hiddenNav: true,
    localeModules: ['aiChat']
  }
};
